function countContentHeight() {

	if(document.querySelector('.main-content') && document.querySelector('.aside-right')) {
		var $mainContent = document.querySelector('.main-content'),
			$asideRight = document.querySelector('.aside-right'),
			mainContentHeight = $mainContent.offsetHeight,
			asideRightHeight = $asideRight.offsetHeight;

		if(mainContentHeight > asideRightHeight) {
			$asideRight.style.minHeight = mainContentHeight + 'px';
		} else if(asideRightHeight > mainContentHeight) {
			$mainContent.style.minHeight = asideRightHeight + 'px';
		}
		
	}
	
}

module.exports = countContentHeight;